// Random metadata generator for ReelGrab

const TITLES = [
  "Личное видео",
  "Момент из жизни",
  "Летний вечер",
  "Домашние заметки",
  "Между делом",
  "Просто так",
  "Утро понедельника",
  "Тихая пятница",
  "Небольшой ролик",
  "Съёмка на память",
  "Прогулка",
  "Первый дубль",
  "Взгляд со стороны",
  "Короткая история",
  "Фрагмент",
  "Из архива",
  "Черновик",
  "Кадр из поездки",
  "Заметка на будущее",
  "Ничего особенного",
];

const ARTISTS = [
  "@archive_notes",
  "@quiet.frames",
  "@daily_drafts",
  "@offline.moments",
  "@no_filter",
  "@morning.rec",
  "@weekend.tape",
  "@slowreels",
  "@notes.for.later",
  "@raw.clip",
  "@midnight.tapes",
  "@studio.404",
  "@paperplane",
  "@lowres.days",
  "@blank.canvas",
];

const ALBUMS = [
  "Черновики",
  "Архив",
  "Заметки",
  "Личное",
  "Backup",
  "2023",
  "2024",
  "Voice Notes",
  "Home Movies",
  "Библиотека",
  "Untitled",
  "Reels Collection",
  "Random",
  "Test Shots",
];

const COMMENTS = [
  "Из архива, без обработки.",
  "Съёмка на телефон, без монтажа.",
  "Кадр без контекста.",
  "Тестовый ролик, не для публикации.",
  "Просто сохранил себе.",
  "Черновик, отложил на потом.",
  "Заметка на память.",
  "Первый дубль, без корректировок.",
  "Ничего важного, просто момент.",
  "Backup file.",
  "Приватная запись.",
  "",
];

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Reference: "YYYY-MM-DDTHH:mm" (upload_date from IG treated as noon)
// Returns a random date at least `minDaysBefore` and at most `maxDaysBefore` earlier.
function randomEarlierDateTime(referenceLocalIso, minDaysBefore = 7, maxDaysBefore = 720) {
  const now = new Date();
  const base = referenceLocalIso ? new Date(referenceLocalIso) : now;
  const ref = Number.isNaN(base.getTime()) ? now : base;

  const shiftDays =
    minDaysBefore + Math.floor(Math.random() * (maxDaysBefore - minDaysBefore + 1));
  const shiftMinutes = Math.floor(Math.random() * 24 * 60); // random time of day

  const out = new Date(ref.getTime());
  out.setDate(out.getDate() - shiftDays);
  out.setHours(0, 0, 0, 0);
  out.setMinutes(shiftMinutes);

  const pad = (n) => n.toString().padStart(2, "0");
  return `${out.getFullYear()}-${pad(out.getMonth() + 1)}-${pad(out.getDate())}T${pad(out.getHours())}:${pad(out.getMinutes())}`;
}

export function randomizeMeta(referenceCreationTime) {
  return {
    title: pick(TITLES),
    artist: pick(ARTISTS),
    album: pick(ALBUMS),
    comment: pick(COMMENTS),
    creation_time: randomEarlierDateTime(referenceCreationTime),
  };
}
